import { render, staticRenderFns } from "./NewCustomerRevenue.vue?vue&type=template&id=a2963b20&"
import script from "./NewCustomerRevenue.vue?vue&type=script&lang=js&"
export * from "./NewCustomerRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports